module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "volume-control-container"
  }, [(_vm.volume > 0) ? _c('img', {
    staticClass: "volume-control-container-img",
    attrs: {
      "src": require("../../assets/image/zbsz_kqmaikefeng_28@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSetVol(0)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.volume == 0) ? _c('img', {
    staticClass: "volume-control-container-img",
    attrs: {
      "src": require("../../assets/image/zbsz_gbmaikefeng_28@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSetVol(100)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "volume-slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100",
      "aria-label": "Volume Level"
    },
    domProps: {
      "value": _vm.volume
    },
    on: {
      "input": _vm.handleVolumeChange
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "volume-control-container-span"
  }, [_vm._v(_vm._s(_vm.volume))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f7b2361"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yinliang/yinliang.vue
// module id = 1032
// module chunks = 1